import SSOAuthPage from './SSOAuthPage';

export default SSOAuthPage;
